export const UNKNOWN_ERROR = 'Неизвестная ошибка';

export function getErrorMsg(error: unknown): string {
  let errorMessage = UNKNOWN_ERROR;

  if (error === undefined) {
    return errorMessage;
  }

  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === 'string') {
      errorMessage = maybeMessage;
    }
  }

  return errorMessage;
}
